export default __webpack_public_path__ + "static/media/logo-ccb-2.d4cc1039.png";